import React from 'react';
import {_GPY} from '../../env.js'

class Dashboad extends React.Component {
  constructor(props) {
   super(props);
   this.state = {};
  }


  setGameType(f){
     this.props.setGameType(f);
  }

	render (){
    return (
        <div className="row justify-content-start p-3">


        {this.props.gameTypes.MenuItems.MenuItem.map((item) => {
          if(item.link === 'Dashboard'){
            return (<div key={item.link} />);
          }
          var iconSrc = _GPY.resource("game_type/"+item.link+"/icon.png");
          var alt = item.link + " Icon";
          return (

          <div  key={item.link}  className="col-12 col-sm-6 col-md-3 col-xl-2 p-3">
           <button className="btn btn-link" onClick={this.setGameType.bind(this,item.link)}><img className="img-fluid w-100 h-100 pointer" src={iconSrc} alt={alt}/></button>
           {/** item.title!==item.description?
             <p className="text-muted text-center">{item.description}</p>
             :
             <p className="text-muted text-center">&nbsp;</p>
           **/}

           <button onClick={this.setGameType.bind(this,item.link)} className="btn btn-light btn-block">{item.title}</button>
          </div>
         )
       })
       }

      </div>
		 	);
    }

}
export default Dashboad;
